var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartHalfStroke(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.74195V19.0966L19.7203 11.8873C20.5359 11.1279 21 10.0638 21 8.9482V8.67633C21 6.86695 19.6922 5.32476 17.9062 5.02476C16.7297 4.82789 15.525 5.21226 14.6813 6.05601L14.1188 6.61851L12 8.74195ZM5.59688 2.06695C7.73438 1.7107 9.90469 2.40914 11.4375 3.93726L12 4.49976L12.5625 3.93726C14.0906 2.40914 16.2656 1.7107 18.4031 2.06695C21.6328 2.60601 24 5.39976 24 8.67633V8.9482C24 10.8935 23.1938 12.7545 21.7687 14.081L13.2984 21.9888C12.9469 22.317 12.4828 22.4998 12 22.4998C11.5172 22.4998 11.0531 22.317 10.7016 21.9888L2.23125 14.081C0.80625 12.7545 0 10.8935 0 8.9482V8.67633C0 5.39976 2.36719 2.60601 5.59688 2.06695Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartHalfStroke);
export default __webpack_public_path__ + "static/media/heart-half-stroke.47f9cb015c5e9a73f2dc198657f80308.svg";
export { ForwardRef as ReactComponent };